import Link from "@qlik/qlik/src/components/Link";
import MarketoForm from "@qlik/qlik/src/components/MarketoForm/MarketoForm";
import React from "react";

/**
 * AccessForm is a React component that either displays a link to a success URL or a MarketoForm based on the `isFormSuccess` prop.
 *
 * @component
 * @param {Object} props The properties object.
 * @param {boolean} props.isFormSuccess Determines whether the form was successfully submitted.
 * @param {Object} props.sectionColorMapping An object containing color mapping for the section.
 * @param {string} props.successUrl The URL to navigate to upon successful form submission.
 * @param {string} props.buttonText Submit button text of the form.
 * @param {Object} props.formCard The form card object to be passed to the MarketoForm component.
 * @param {Function} props.onFormSuccess The callback function to be executed upon successful form submission.
 * @returns {JSX.Element} A div element containing either a Link component or a MarketoForm component.
 */
const AccessForm = ({ isFormSuccess, sectionColorMapping, successUrl, buttonText, formCard, onFormSuccess }) =>
    isFormSuccess ? (
        <div
            className={`px-5 py-11 lg:p-10.25 ${
                sectionColorMapping?.bgColor ? "bg-white border border-stone/50 rounded shadow-xxl" : "bg-blue"
            }`}
        >
            <Link
                to={successUrl}
                className={`w-full ${
                    sectionColorMapping?.bgColor ? "btn-primary-large" : "btn-primary-large-invert-2"
                }`}
            >
                {buttonText}
            </Link>
        </div>
    ) : (
        <div
            className={`px-5 py-11 lg:p-10.25 ${
                sectionColorMapping?.bgColor ? "bg-white border border-stone/50 rounded shadow-xxl" : "bg-blue"
            }`}
        >
            <MarketoForm form={formCard} isDark={!sectionColorMapping?.bgColor} onFormSuccess={onFormSuccess} />
        </div>
    );

export default AccessForm;
